import { Injectable } from '@angular/core';

import { AxisData } from '../chart/axis-data';

import { PlotPoint } from './scatterplot.model';

@Injectable()
export class ScatterPlotService {
    userOutcomeTarget: string = '';
    userBehaviourTarget: string = '';
    rawData: any[] = new Array<any>();

    selectedUser: string = '';
    selectedRole: string = '';
    selectedBehavior: number;
    selectedOutcome: number;
    selectedBehaviorName: string;
    selectedOutcomeName: string;
    selectedDate: string = '';
    startDate: string = '';

    getPlotData(): PlotPoint[] {
        const resp = new Array<PlotPoint>();
        if (this.rawData.length > 0) {
            this.rawData.forEach((element) => {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                resp.push({
                    x: element.behaviour,
                    y: element.outcome,
                    r: 1,
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    t: `${element.firstName} ${element.lastName}`,
                });
            });
            return resp;
        } else {
            return null;
        }
    }

    getPlotData2(): AxisData {
        const showLines = this.showPlotAnotations();
        return {
            paths: [
                {
                    points: this.rawData.map(
                        (element: {
                            behaviour: number;
                            outcome: number;
                            firstName: string;
                            lastName: string;
                        }) => {
                            return {
                                x: element.behaviour,
                                y: element.outcome,
                                color: 'red',
                                text: `${element.firstName} ${element.lastName}`,
                            };
                        },
                    ),
                },
            ],
            behaviourText: 'Behaviour',
            outcomeText: 'Outcome',
            behaviourTarget: showLines
                ? parseFloat(this.userBehaviourTarget)
                : null,
            behaviourTargetText: 'Target Behaviour',
            outcomeTarget: showLines
                ? parseFloat(this.userOutcomeTarget)
                : null,
            outcomeTargetText: 'Target Outcome',
        };
    }

    public showPlotAnotations(): boolean {
        if (this.userBehaviourTarget && this.userOutcomeTarget) {
            return (
                Number(this.userBehaviourTarget) > 0 &&
                Number(this.userOutcomeTarget) > 0
            );
        } else {
            return false;
        }
    }
}
